import { CountryCode } from '@dayetopia/library/types';
import AT from '@icons/flags/AT.svg';
import BE from '@icons/flags/BE.svg';
import BG from '@icons/flags/BG.svg';
import CH from '@icons/flags/CH.svg';
import DE from '@icons/flags/DE.svg';
import DK from '@icons/flags/DK.svg';
import ES from '@icons/flags/ES.svg';
import FI from '@icons/flags/FI.svg';
import FR from '@icons/flags/FR.svg';
import GB from '@icons/flags/GB.svg';
import IE from '@icons/flags/IE.svg';
import IT from '@icons/flags/IT.svg';
import NL from '@icons/flags/NL.svg';
import NO from '@icons/flags/NO.svg';
import PT from '@icons/flags/PT.svg';
import SE from '@icons/flags/SE.svg';
import US from '@icons/flags/US.svg';

const flags: Record<CountryCode, string> = {
  GB,
  DE,
  NL,
  IE,
  BE,
  IT,
  ES,
  PT,
  BG,
  FR,
  US,
  SE,
  DK,
  NO,
  FI,
  AT,
  CH
};

export default flags;
